export default {
  state:{
    fileData:{},
  },
  mutations:{
    alterFile(state,fileDate){
      this.state.fileData = fileDate;
    }
  },
  action:{
  },
  getter:{
    getFileData(state){
      return state.fileData
    }
  }
}
